var map = {
	"./Card.vue": 9889,
	"./Item.vue": 885,
	"./ItemGroup.vue": 2995,
	"./ItemSubGroup.vue": 4061,
	"./MaterialAlert.vue": 1264,
	"./MaterialCard.vue": 820,
	"./MaterialChartCard.vue": 3435,
	"./MaterialSnackbar.vue": 5229,
	"./MaterialStatsCard.vue": 3898,
	"./MaterialTabs.vue": 2324,
	"./MaterialTestimony.vue": 9211,
	"./Subheading.vue": 9078,
	"./VComponent.vue": 7457,
	"./baseTable.vue": 4328,
	"./imageInputFile.vue": 8730,
	"./pagination.vue": 9580,
	"./secondSpinner.vue": 6300,
	"./spinner.vue": 6849,
	"./tableDeleteModal.vue": 5266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5190;